// src/components/ui/RedeemCouponHeader.jsx
//
// Mobile-only sticky header for RedeemCoupon.jsx, same glass-card
// language and same self-contained wrapper as WalletHeader/CartHeader
// (mx-auto max-w-8xl px-2 sm:px-4 md:px-6 lg:px-8 py-3) — RedeemCoupon
// now follows ContactFormPreview's structure, where this big header
// only appears on small screens and a compact CardHeader takes over
// inside the white card on sm: and up.
//
// Icon is the same vector ticket glyph used by RedeemCoupon.jsx's
// desktop CardHeader (not an emoji), so the icon doesn't visibly swap
// shape when crossing the sm: breakpoint between this header and that
// one.
import React from 'react';

const RedeemCouponHeader = ({
  title = 'מימוש קופון גפ״ן',
  subtitle = 'סריקת קוד QR או הזנת קוד ידנית מוסיפה קרידט לתוכנית שלך',
}) => (
  <section className="mx-auto max-w-8xl px-2 sm:px-4 md:px-6 lg:px-8 py-3" dir="rtl">
    <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-50 to-blue-50" />

      <div className="relative bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl sm:rounded-3xl p-4 sm:p-5 lg:p-6 shadow-2xl shadow-indigo-100/50">
        <div className="flex items-center gap-3 sm:gap-4 min-w-0">
          <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md">
            <svg
              viewBox="0 0 24 24"
              className="w-5 h-5 sm:w-6 sm:h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              aria-hidden="true"
            >
              <path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 1 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 1 0 0-4V8Z" />
              <path d="M13 6v2M13 11v2M13 16v2" strokeLinecap="round" />
            </svg>
          </div>

          <div className="min-w-0 flex-1">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent leading-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm sm:text-base text-gray-600 mt-0.5 sm:mt-1 line-clamp-2 sm:truncate">
                {subtitle}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default RedeemCouponHeader;